
export enum BannerTipo {
    EXTERNO = "Externo",
    INTERNO = "Interno"
}